import { styled } from '@mui/material/styles';

export const StyledContainer = styled('div')(({ theme }) => ({
  padding: theme.spacing(2),
  width: `calc(100% - ${theme.spacing(4)})`,
  clear: 'both',

  [theme.breakpoints.down('md')]: {
    padding: 0,
  },

  pageBreakInside: 'avoid !important',
}));
